import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.insertPhoneNumberUserRegistration.pageTitle',
    defaultMessage: 'Verifica numero di cellulare',
    description: 'Title of the insert phone number user registration page',
  },
  pageSubtitle: {
    id: 'features.insertPhoneNumberUserRegistration.pageSubtitle',
    defaultMessage:
      'Inserisci il numero di cellulare che desideri associare al servizio',
    description: 'Subtitle of the insert phone number user registration page',
  },
  buttonSendCodeByPhone: {
    id: 'features.insertPhoneNumberUserRegistration.buttonSendCodeByPhone',
    defaultMessage: 'OK',
    description:
      'Label of the insert phone number user registration button send code',
  },
  labelInsertPhoneNumberInputText: {
    id: 'features.insertPhoneNumberUserRegistration.labelInsertPhoneNumberInputText',
    defaultMessage: 'Numero di cellulare',
    description: 'Label of phone input text',
  },
  placeholderInsertPhoneNumberInputText: {
    id: 'features.insertPhoneNumberUserRegistration.placeholderInsertPhoneNumberInputText',
    defaultMessage: 'Numero di cellulare',
    description: 'Placeholder of phone input text',
  },
  descriptionDisclaimerInsertPhoneNumber: {
    id: 'features.insertPhoneNumberUserRegistration.descriptionDisclaimerInsertPhoneNumber',
    defaultMessage:
      'Nel caso in cui si voglia modificare il numero di cellulare, è necessario accedere al proprio MyAzimut ed effettuare la richiesta di variazione',
    description: 'Text of description disclaimer insert phone number',
  },
  errorInvalidPhoneNumberFormat: {
    id: 'features.insertPhoneNumberUserRegistration.errorPhoneNumberInvalidFormat',
    defaultMessage:
      'Numero di cellulare non corretto. Si prega di controllare.',
    description: 'Error invalid phone numeber format ',
  },
  errorPhoneNumberNotUsableMessages: {
    id: 'features.insertPhoneNumberUserRegistration.errorPhoneNumberNotUsable',
    defaultMessage:
      'Il numero di cellulare risulta già associato ad un altro contratto My Azimut. Si prega di inserire un altro numero di cellulare',
    description:
      'Error message phone number not usable verification phone number ',
  },
  errorPhoneNumberAlreadyUsedMessages: {
    id: 'features.insertPhoneNumberUserRegistration.errorPhoneNumberAlreadyUsedMessages',
    defaultMessage:
      'Il numero di cellulare inserito coincide con quello precedentemente verificato. Si prega di inserire un altro numero di cellulare.',
    description:
      'Error message phone number not usable verification phone number ',
  },
});
